import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from './demo/service/auth.service';
import { map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.ensureTokenIsValid().pipe(
    map(isValid => {
      if (isValid) {
        return true;
      } else {
        router.navigate(['/']);
        return false;
      }
    })
  );
};

export const childAuthGuard: CanActivateChildFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    return authService.ensureTokenIsValid().pipe(
      map(isValid => {
        if (isValid) {
          return true;
        } else {
          router.navigate(['/']);
          return false;
        }
      })
    );
  };


